import { render, staticRenderFns } from "./CardBasicGroup.vue?vue&type=template&id=956d9a42&"
import script from "./CardBasicGroup.vue?vue&type=script&lang=js&"
export * from "./CardBasicGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports